import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth/AuthContext';
import { REDIRECT_KEY } from '../lib/auth/ProtectedRoute';

export function AuthCallback() {
  const { status, error } = useAuth();
  const navigate = useNavigate();

  // NOTA: NO limpiamos el hash con replaceState — competía con el procesamiento
  // del Supabase JS SDK (detectSessionInUrl). El SDK lo maneja internamente
  // durante INITIAL_SESSION; cualquier interferencia rompe la captura del token.

  useEffect(() => {
    if (status === 'authenticated') {
      const target = sessionStorage.getItem(REDIRECT_KEY) ?? '/';
      sessionStorage.removeItem(REDIRECT_KEY);
      navigate(target, { replace: true });
    } else if (status === 'orphan') {
      navigate('/login', { replace: true });
    }
  }, [status, navigate]);

  return (
    <div className="min-h-screen bg-calbucura-gray-light flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        {status === 'loading' && (
          <p className="text-gray-700">Validando tu acceso…</p>
        )}
        {status === 'unauthenticated' && (
          <>
            <p className="text-gray-700 mb-4">
              {error ?? 'No pudimos validar el enlace. Puede haber expirado.'}
            </p>
            <button
              type="button"
              onClick={() => navigate('/login', { replace: true })}
              className="bg-calbucura-orange hover:bg-calbucura-orange-dark text-white font-semibold py-2 px-4 rounded-md"
            >
              Volver al inicio de sesión
            </button>
          </>
        )}
      </div>
    </div>
  );
}
